module.exports = __webpack_public_path__ + "static/img/school-illustration.ed364006.png";